export default "__VITE_ASSET__CMfbQGAb__"